import {
  coreExtensionData,
  createExtensionInput,
} from '@backstage/frontend-plugin-api';
import catalogFrontendPlugin from '@backstage/plugin-catalog/alpha';
import { EntityAnalyticsTracker } from '../../components/catalog/EntityAnalyticsTracker';

// PAT-1027: the entity page is the alpha catalog's `page:catalog/entity`, with
// the tabs and overview cards of the legacy `EntityPage.tsx` converted by
// compat. This override keeps it (same id, path, route ref, config and
// inputs) and changes two things:
//
// - It mounts `EntityAnalyticsTracker` next to the page, once for every tab.
//   Compat only keeps the routes of `entityPage`, so the tracker can no longer
//   sit at its root. It is outside the page's entity provider and loads the
//   entity itself.
// - It declares the `childRoutingShims` input. Compat attaches one routing shim
//   per `path` in `entityPage` there, and the alpha page has no such input, so
//   each one would be logged as a warning at startup.
export const catalogEntityPageOverride = catalogFrontendPlugin
  .getExtension('page:catalog/entity')
  .override({
    inputs: {
      childRoutingShims: createExtensionInput([
        coreExtensionData.routePath.optional(),
        coreExtensionData.routeRef.optional(),
      ]),
    },
    *factory(originalFactory) {
      const page = originalFactory();
      // Route path, route ref and title stay as upstream.
      yield* page;
      // Same id as the original element, so it replaces it.
      yield coreExtensionData.reactElement(
        <>
          <EntityAnalyticsTracker />
          {page.get(coreExtensionData.reactElement)}
        </>,
      );
    },
  });
